// DetailSheet (TEMPLATES.md): right drawer on tablet/desktop, bottom sheet
// on phone. Player card, claim flow, trade detail. The sheet itself is the
// kit's (`kit/overlays.tsx`), so a look styles it in one place.

import type { ReactNode } from 'react';
import { Sheet } from '../kit/overlays';

export function DetailSheet({
  opened,
  onClose,
  title,
  children,
  wide = false,
  zIndex,
  closeOnEscape = true,
}: {
  opened: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  /** A wider drawer on tablet and desktop: the trade builder's two rosters side by side. */
  wide?: boolean;
  /** Above a full-screen moment (the champion overlay sits at 1000). */
  zIndex?: number;
  /**
   * False while something inside the sheet owns Escape — a color picker's
   * dropdown (Edit team) — so the key closes that and not the sheet with an
   * edit in it.
   */
  closeOnEscape?: boolean;
}) {
  return (
    <Sheet
      opened={opened}
      onClose={onClose}
      title={title}
      wide={wide}
      zIndex={zIndex}
      closeOnEscape={closeOnEscape}
    >
      {children}
    </Sheet>
  );
}
